import React from 'react';
import ReactDOM from 'react-dom/client';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './store/store';
import './css/variables.css';
import './css/fonts.css';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(

      <Provider store={store}>
        <App />
      </Provider>
);
